import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="text-slate-400 py-10">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <Link to="/" className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl flex items-center justify-center bg-blue-50 text-blue-700">
            <ShieldCheck size={20} />
          </div>
          <div>
            <p className="font-heading font-bold text-slate-900">RevUShield</p>
          </div>
        </Link>

        <div className="flex gap-6 text-sm">
          <a href="/legal/privacy" className="hover:text-blue-700 transition">
            Privacy Policy
          </a>

          <a href="/legal/terms" className="hover:text-blue-700 transition">
            Terms of Service
          </a>
        </div>

        <a
          href="mailto:support@revushield.com"
          className="text-sm hover:text-blue-700 transition"
        >
          support@revushield.com
        </a>
      </div>
    </footer>
  );
}
